import {logDplWithExtensionParams, EVENTS} from '../../../util/dpl'

const onCtaClick = (ctaType, experiment, ctaUrl = 'https://www.startpage.com') => {
    return (e) => {
        e.preventDefault()
        logDplWithExtensionParams(EVENTS.StartpageClick, {
            type: ctaType,
            experiment,
        })
            .then(() => {
                window.location.href = ctaUrl
            })
            .catch((err) => {
                console.error(err)
            })
    }
}

export default onCtaClick
